export default {

    common_loading: 'लोड हो रहा है',
    common_cancel: 'रद्द करें',
    common_confirm: 'पुष्टि करें',
    common_continue: 'जारी रखें',
    common_submit: 'सबमिट करें',
    common_token_expire: 'टोकन की समयसीमा समाप्त हो गई है, कृपया पुनः लॉग इन करें। ',
    common_modify_success: 'संशोधन सफल',
    common_success: 'सफलता',

    common_home: 'होमपेज',
    common_market: 'बाज़ार',
    common_msgs: 'संदेश',
    common_find: 'ढूंढें',
    common_me: 'मैं',

    common_deposit: 'जमा',
    common_withdraw: 'वापस लेना',
    common_team: 'टीम',
    common_channel: 'चैनल',
    common_service: 'सेवा',
    common_currency: 'मुद्रा',
    common_more: 'अधिक',
    common_detail: 'विस्तृत जानकारी',
    common_search: 'खोज',
    common_language: 'भाषा',
    common_share: 'साझा करें',
    common_logout: 'लॉगआउट',
    common_copy_success: 'कॉपी सफल',
    common_send: 'भेजें',
    common_empty_data: 'कोई डेटा नहीं',
    common_created: 'बनाया गया',
    common_time: 'समय',
    common_download_app: 'ऐप डाउनलोड करें',
    common_download: 'डाउनलोड',

    toast_input_phone: 'कृपया अपना फ़ोन नंबर दर्ज करें',
    toast_input_password: 'कृपया अपना पासवर्ड दर्ज करें',
    toast_input_full_name: 'कृपया अपना पूरा नाम दर्ज करें',
    toast_input_email: 'कृपया अपना ईमेल पता दर्ज करें',
    toast_input_refcode: 'कृपया संदर्भ कोड दर्ज करें',
    toast_input_old_password: 'कृपया अपना पुराना पासवर्ड दर्ज करें',
    toast_input_new_password: 'कृपया नया पासवर्ड दर्ज करें',
    toast_input_repeat_password: 'कृपया दोहराया गया पासवर्ड दर्ज करें',
    toast_input_repeat_password_nosame: 'दोनों पासवर्ड अलग-अलग हैं',
    toast_input_phone_length: 'फ़ोन नंबर 10 अंकों से कम नहीं हो सकता',

    login_welcome: 'आपका पुनः स्वागत है! ',
    login_subtitle: 'अपने खाते में लॉग इन करें',
    login_no_account: 'कोई खाता नहीं? ',
    register_title: 'खाता बनाएँ',
    register_subtitle: 'आइये एक निःशुल्क मात्रात्मक ट्रेडिंग खाता शुरू करें',
    register_have_account: 'क्या आपके पास पहले से ही खाता है? ',
    user_phone: 'मोबाइल फ़ोन नंबर',
    user_password: 'पासवर्ड',
    user_forget_password: 'अपना पासवर्ड भूल गए? ',
    user_sign_in: 'लॉगिन',
    user_sign_up: 'पंजीकरण करें',
    user_full_name: 'पूरा नाम',
    user_email: 'ईमेल',
    user_verife_code: 'सत्यापन कोड',
    user_ref_code: 'आमंत्रण कोड',
    user_old_password: 'पुराना पासवर्ड',
    user_new_password: 'नया पासवर्ड',
    user_repeat_password: 'पासवर्ड दोहराएँ',
    user_find_password: 'मेरा पासवर्ड ढूंढें',
    user_modify_password: 'मेरा पासवर्ड संशोधित करें',
    user_modify_login_password: 'लॉगिन पासवर्ड संशोधित करें',
    user_account_security: 'खाता सुरक्षा',

    user_center: 'उपयोगकर्ता केंद्र',
    user_invite_reward_title: 'कम से कम 10% बोनस प्राप्त करें',
    user_invite_reward_desc: 'दोस्तों को शामिल होने के लिए आमंत्रित करें और असीमित बोनस प्राप्त करें',
    user_invite_records: 'आमंत्रित पुरस्कार रिकॉर्ड',
    user_security_protect: 'खाते की सुरक्षा बनाए रखें',

    user_kefu_title1: 'हमसे संपर्क करें',
    user_kefu_title2: 'विधि इस प्रकार है',
    user_kefu_24hour_hint: '24 घंटे ऑनलाइन ग्राहक सेवा',
    user_kefu_notice: 'जब आमंत्रित उपयोगकर्ता टॉप-अप करेगा, तो पुरस्कार स्वचालित रूप से आपके खाते की शेष राशि में जोड़ दिया जाएगा',
    user_invited: 'आमंत्रित',

    share_hint: 'जब आमंत्रित उपयोगकर्ता टॉप-अप करेगा, तो पुरस्कार स्वचालित रूप से आपके खाते की शेष राशि में जोड़ दिया जाएगा',
    share_copy_link: 'लिंक कॉपी करें और साझा करें',
    share_rewards_record: 'पुरस्कार रिकॉर्ड',
    home_total_asset_value: 'कुल संपत्ति मूल्य',
    msg_msgs: 'संदेश',
    msg_contacts: 'संपर्क',
    wallet_balance: 'शेष',
    wallet_salary_balance: 'वेतन शेष',
    wallet_update_bank: 'निकासी बैंक अपडेट करें',
    wallet_account_settlement: 'खाता निपटान',
    wallet_payroll_records: 'पेरोल रिकॉर्ड',
    wallet_financial_records: 'वित्तीय रिकॉर्ड',
    wallet_trade_history: 'लेनदेन इतिहास',
    wallet_update_bank_info: 'बैंक जानकारी अपडेट करें',
    wallet_update_bank_hint: 'एक ही खाते को केवल एक ही खाते से जोड़ा जा सकता है',
    wallet_update_bank_input_name: 'कृपया अपना नाम दर्ज करें',
    wallet_update_bank_input_cardno: 'निकासी आवेदन खाता (संख्या)',
    wallet_update_bank_input_ifsc: 'कृपया ifsc दर्ज करें',
    wallet_update_bank_input_bankname: 'कृपया बैंक का नाम दर्ज करें',
    wallet_update_bank_input_otp: 'कृपया शाखा ओटीपी दर्ज करें',
    wallet_bind_bank_message: 'आपने अभी तक अपना बैंक कार्ड बाइंड नहीं किया है। क्या आप इसे अभी बाइंड करना चाहते हैं?',
    wallet_bind_bank_go: 'बाइंड पर जाएं',

    deposit_recommend_amount: 'अनुशंसित राशि',
    deposit_select_channel_title: 'कृपया जमा चैनल चुनें',
    withdraw_available_balance: 'उपलब्ध शेष राशि',
    withdraw_amount: 'राशि',
    withdraw_taxs: 'कर',
    withdraw_total_amount: 'कुल राशि',
    withdraw_select_bank: 'बैंक चुनें',
    withdraw_notice: 'निकासी शुल्क 20% कर है, निकासी का समय सोमवार से शुक्रवार सुबह 7:00-9:00 बजे तक है, 2. वेतन निकासी का समय सोमवार से रविवार सुबह 7:00-9:00 बजे तक है',
    withdraw_password_modify_title: 'निकासी पासवर्ड संशोधित करें',
    withdraw_set_paypassword_message: 'निकासी पासवर्ड अभी तक सेट नहीं किया गया है क्या आप इसे अभी सेट करना चाहते हैं? ',
    withdraw_pay_password_input: 'कृपया निकासी पासवर्ड दर्ज करें',

    trade_ordering: 'ट्रेडिंग',
    trade_history: 'इतिहास',
    trade_past_24: 'पिछले 24 घंटे',
    trade_market_detail: 'बाजार विवरण',
    trade_open_price: 'खुली कीमत',
    trade_vol: 'आयतन',
    trade_high: 'उच्च',
    trade_low: 'कम',
    trade_call: 'कॉल',
    trade_put: 'पुट',
    trade_path: 'पथ',
    trade_signal_rate: 'सिग्नल दर',
    trade_position: 'स्थिति',
    trade_status: 'स्थिति',
    trade_waiting: 'प्रतीक्षारत',
    trade_profit: 'लाभ',
    trade_loss: 'हानि',
    trade_settlement: 'निपटान',
    trade_product: 'उत्पाद',
    trade_close_price: 'बंद कीमत',
    trade_order_detail: 'ऑर्डर विवरण',

    chat_message_deleted: 'यह संदेश हटा दिया गया है',
    chat_message_empty: "अभी तक कोई संदेश नहीं",
    chat_conversation_started: 'चैट शुरू हुई:',
    chat_type_message: 'इनपुट संदेश',
    chat_reply: 'उत्तर',

    channel_signal: 'सिग्नल चैनल',

    team_level_1: 'लेवल-1',
    team_level_2: 'लेवल-2',
    team_level_3: 'लेवल-3',
    team_reg_num: 'पंजीकृत लोगों की कुल संख्या',
    team_recharge_num: 'रिचार्ज करने वालों की कुल संख्या',
    team_recharged: 'रिचार्ज किया गया',
    team_unrecharge: 'रिचार्ज नहीं किया गया',

    user_remember_password: 'पासवर्ड याद रखें',
    common_trade: 'व्यापार',
    common_time: 'समय',
    currency_name: 'नाम',
    currency_latest_price: 'नवीनतम मूल्य',
    currency_rise_and_fall: 'वृद्धि और गिरावट',
    trade_high_today: 'आज उच्च',
    trade_low_today: 'आज कम',
    trade_direction: 'दिशा',
    trade_buy_more: "अधिक खरीदें",
    trade_buy_less: "कम खरीदें",
    time_min: 'मिनट',
    time_hour: 'घंटा',
    time_day: 'दिन',
    time_week: 'सप्ताह',
    time_mon: 'सोम',

    follow_order_title: 'शीर्ष व्यापारियों का अनुसरण करें और पैसा कमाएं',
    follow_order_desc: 'आप उत्कृष्ट व्यापारियों की रणनीतियों की नकल कर सकते हैं, स्वचालित रूप से आदेशों का पालन कर सकते हैं और मुनाफा कमा सकते हैं',
    common_now_try: 'अभी अनुभव करें',

    welfare_activity_title: 'नवीनतम कल्याणकारी गतिविधियाँ',
    welfare_activity_desc: 'कृपया हमारी नवीनतम ईवेंट नीति के बारे में जानने के लिए होम पेज पर समाचारों पर नज़र रखें!',
    appdownload:'डाउनलोड',
    welfarecenter:'कल्याण केंद्र',
}